module.exports = __webpack_public_path__ + "img/allow_popups.858cc573.png";